import React from 'react';
import { useFormContext } from 'react-hook-form';
import { PaymentType } from '@trnsact/trnsact-shared-types';
import { SelectField } from 'components/form/rhf';
import { FinanceFilters } from '../types';

const options: { label: string; value: 'ALL' | PaymentType }[] = [
  { label: 'All', value: 'ALL' },
  { label: 'Cash', value: PaymentType.Cash },
  { label: 'Credit Line', value: PaymentType.CreditLine },
  { label: 'Financing', value: PaymentType.Financing },
];

export const FinancePaymentType = () => {
  const { control } = useFormContext<FinanceFilters>();

  return (
    <SelectField
      size="small"
      variant="outlined"
      name="PAYMENT_TYPE"
      label="Payment Type"
      control={control}
      options={options}
    />
  );
};
